import classNames from "classnames";
import React from "react";
import "./index.scss";
export interface IProps {
  classes?: string;
}
const LoadingCircle: React.FC<IProps> = ({ classes }) => (
  <div className={classNames("loader", classes)} />
);

export default LoadingCircle;
